module.exports = __webpack_public_path__ + "static/media/gilroy-extrabold-webfont.b79f3b8f.woff";